import { Component, OnInit } from '@angular/core';
import { ScreeningService } from '../services/screening.service';
import { Router } from '@angular/router';
import { __asyncDelegator } from 'tslib';
import { AuthService } from '../services/auth.service';
import { ElementSchemaRegistry } from '@angular/compiler';
import { ToastrService } from 'ngx-toastr';
import { ChannelService, ChannelEvent } from '../services/channel.service';
import { ApplicantDataService } from '../services/applicant-data.service';
import { ScreeningLog, LogParserType, UserLog } from '../models/LogEntry';
import { environment } from 'src/environments/environment';
import { CookieService } from 'ngx-cookie-service';

@Component({
  selector: 'app-final-screen',
  templateUrl: './final-screen.component.html',
  styleUrls: ['./final-screen.component.less']
})
export class FinalScreenComponent implements OnInit {
  screeningSaved : boolean = false;
  midSave : boolean = false;
  showNavRIQ : boolean = false;
  processing: boolean = false;
  constructor(public applicantData : ApplicantDataService , public screeningSrv: ScreeningService, public location: Router, public auth : AuthService, public toast : ToastrService, public channels : ChannelService, public cook : CookieService) {
    this.auth.titleBarText = this.screeningSrv.screeningType == 'applicant' ? "Thank your for Screening" : "Thank you for setting up your user account.";
    if (this.screeningSrv.questions.hasTC) {

    }
    // this.screeningSrv.questions.
    console.log(this.screeningSrv.questions.DataModel);



  }

  back(){
    this.location.navigateByUrl('/demographics')
  }

  navigateToRIQ() : void {
    window.location.href = environment.dashboardUrl + '/sso';
  }

  saveScreening() {
    this.processing = true;
    if(!this.midSave){
      this.midSave = true;
      this.screeningSrv.saveScreening().subscribe((ev : any) => {
        console.log('sent screening.');
        console.log(ev);
        this.applicantData.screeningInvite = ev.invite;
        // TODO: start listening on this token
        // let evt = new ChannelEvent();
        // evt.channelName = "JoinGroup";
        // evt.data = this.screeningSrv.screeningToken;
        // this.channels.publish(evt);

        // if(ev.hasPaymentLink){
        //   window.location = ev.paymentUrl
        // }else{
        //   // If its not an applicant then send them to the screenings page.
          this.screeningSaved = true;
        //   if(this.screeningSrv.questions.DataModel.invitation.applicantReview){
        //     this.location.navigateByUrl('/review-wait');
        //   }else{
        //     //show nav button
            this.showNavRIQ = true;
            this.cook.deleteAll();
            this.cook.set('resIq', ev.tkn, 0.5, '/' , '.residentiq.com', true); // Set the JWT token in a cookie so we can forward user over to dashboard.
            // Log the user into the dashboard and make them set their username
          // }

        //
        // }
        // TODO : show a loader that completes when the screening saves.
        // Once the screening has saved if this is an applicant pay invitation then it will send back a link. send the user to it.
      },(err: any)=>{
        this.toast.error("There was an error saving your info. please contact support for assistance.")
      })
    }else{
      this.toast.info('Your information is currently saving. please wait while we process your information.');
    }

  }
  ngOnInit() {
  }

}
